import React, { Component, useState } from 'react'
import { withRouter } from '../../utils/with-router'
import './Members.css'
import BoardMembers from './BoardMembers/BoardMembers';
import Volunteers from './Volunteers/Volunteers';
import ExecutiveMembers from './ExecutiveMembers/ExectiveMembers';
import avatar from '../Home/Speaker/speakers_avatars/avatar.svg'
import paul from '../Home/Speaker/speakers_avatars/paul.svg'
import han from '../Home/Speaker/speakers_avatars/han.svg'
import alan from '../Home/Speaker/speakers_avatars/alan.svg'
import photo from '../Members/pics/photo.png'
class Members extends Component {
    constructor(props) {
        super(props);
        this.state = {

            isBorderMember:true,
            isVolunteer:false,
            isVisible: true,

        };
    }




    toggleVisibility1 = () => {
        this.setState(prevState => ({
            isBorderMember: false,
            isVisible: true,

        }));
        const boardMemberContainer = document.querySelector('.boardmember-container');
        if (boardMemberContainer) {
            boardMemberContainer.style.backgroundColor = 'rgba(217, 217, 217, 0.4)';
        }
        const executeMemberContainer = document.querySelector('.executemember-container');
        if (executeMemberContainer) {
            executeMemberContainer.style.backgroundColor = 'rgba(217, 217, 217, 0.4)';
        }
        const volunteerContainer = document.querySelector('.volunteer-container');
        if (volunteerContainer) {
            volunteerContainer.style.backgroundColor = '#D9D9D9';
        }
    };

    toggleVisibility2 = () => {
        this.setState(prevState => ({
            isVisible: true,
            isBorderMember: true,

        }));
        const boardMemberContainer = document.querySelector('.boardmember-container');
        if (boardMemberContainer) {
            boardMemberContainer.style.backgroundColor = '#D9D9D9';
        }
        const volunteerContainer = document.querySelector('.volunteer-container');
        if (volunteerContainer) {
            volunteerContainer.style.backgroundColor = 'rgba(217, 217, 217, 0.4)';
        }
        const executeMemberContainer = document.querySelector('.executemember-container');
        if (executeMemberContainer) {
            executeMemberContainer.style.backgroundColor = 'rgba(217, 217, 217, 0.4)';
        }
    };

    toggleVisibility3 = () => {
        this.setState(prevState => ({
            isVisible: false,
            isBorderMember: false,
            isVolunteer: false
        }));
        const boardMemberContainer = document.querySelector('.boardmember-container');
        if (boardMemberContainer) {
            boardMemberContainer.style.backgroundColor = 'rgba(217, 217, 217, 0.4)';
        }
        const volunteerContainer = document.querySelector('.volunteer-container');
        if (volunteerContainer) {
            volunteerContainer.style.backgroundColor = 'rgba(217, 217, 217, 0.4)';
        }
        const executeMemberContainer = document.querySelector('.executemember-container');
        if (executeMemberContainer) {
            executeMemberContainer.style.backgroundColor = '#D9D9D9';
        }
    };

    render(){
        const { isVisible,isBorderMember } = this.state;

        return (
            <div className = "cover-container">
                <h1 class='member_header_title'>Our Members</h1>
                <div class='member-header'>

                    <div className="photo-container">
                        {/* <img className="member-photo" src={require('../Members/pics/photo2.svg').default} /> */}
                        <img className="member-photo" src={photo} />

                    </div>
                </div>
                <div class='member-white-container'>
                    <div class='flex-container'>
                        {/* <button class='boardmember-container' onClick={this.toggleVisibility2}>
                            {/* {isBoardMember &&   <h2 class='button_title'>Board Members</h2> } 
                            <h2 class='button_title'>Board Members</h2>
                        </button>



                        <button class='volunteer-container' onClick={this.toggleVisibility1}>
                            <h2 class='button_title'>Volunteers</h2>
                        </button> */}

                        <button class='boardmember-container' onClick={this.toggleVisibility2}>
                                <h2 class='button_title'>Board Members</h2>
                            </button>

                            <button class='executemember-container' onClick={this.toggleVisibility3}>
                                <h2 class='button_title'>Executive Team</h2>
                            </button>

                            <button class='volunteer-container' onClick={this.toggleVisibility1}>
                                <h2 class='button_title'>Volunteers</h2>
                            </button>

                    </div>
                    <div class='panel-container'>

                        {/* {isVisible &&  <BoardMembers/>}
                        {!isVisible &&  <Volunteers/>} */}
                        {isVisible && isBorderMember && <BoardMembers />}
                        {isVisible && !isBorderMember && <Volunteers />}
                        {!isVisible && <ExecutiveMembers />}

                    </div>
                </div>

            </div>
        )
    }
}

export default withRouter(Members);